import Vue from 'vue';
import Vcalendar from 'v-calendar';

Vue.use(Vcalendar, {
    firstDayOfWeek: 2,
    masks: {
        weekdays: 'WW',
    },
});
